import React from "react";
import { Box, Tooltip, Zoom } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

/**
 * Floating WhatsApp click-to-chat button.
 *
 * Number: Dr.Paw clinic mobile — 70 886 078 → +961 70 886 078.
 * wa.me expects the full international number with no "+" or spaces.
 */
const WHATSAPP_NUMBER = "96170886078";
const PREFILLED_MESSAGE = "Hi Dr.Paw! I'd like to ask about";

const waLink =
  `https://wa.me/${WHATSAPP_NUMBER}?text=` +
  encodeURIComponent(PREFILLED_MESSAGE);

const WhatsAppButton: React.FC = () => (
  <Tooltip title="Chat with us on WhatsApp" placement="left" arrow TransitionComponent={Zoom}>
    <Box
      component="a"
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Dr.Paw on WhatsApp"
      sx={{
        position: "fixed",
        bottom: { xs: 20, md: 28 },
        right: { xs: 20, md: 28 },
        zIndex: 1300,
        width: { xs: 54, md: 60 },
        height: { xs: 54, md: 60 },
        borderRadius: "50%",
        backgroundColor: "#25D366",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "none",
        boxShadow: "0 6px 20px rgba(37,211,102,0.45)",
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
        "&:hover": {
          transform: "translateY(-3px) scale(1.05)",
          boxShadow: "0 10px 26px rgba(37,211,102,0.55)",
        },
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          borderRadius: "50%",
          border: "2px solid rgba(37,211,102,0.6)",
          animation: "waPulse 2.2s ease-out infinite",
        },
        "@keyframes waPulse": {
          "0%": { transform: "scale(1)", opacity: 0.7 },
          "100%": { transform: "scale(1.6)", opacity: 0 },
        },
      }}
    >
      <WhatsAppIcon sx={{ fontSize: { xs: 28, md: 32 } }} />
    </Box>
  </Tooltip>
);

export default WhatsAppButton;
